var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgDoubleSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1231,
    viewBox: "0 0 1024 1231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M47.8818 256.847C-14.6273 319.356 -14.6273 421.644 47.8818 484.153L746.847 1183.12C809.356 1245.63 911.644 1245.63 974.153 1183.12L1673.12 484.153C1735.63 421.644 1735.63 319.356 1673.12 256.847L976.047 -442.118C913.538 -504.627 811.25 -504.627 748.741 -442.118L47.8818 256.847Z",
    stroke: "#002853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M113.959 266.088C56.5325 323.514 56.5325 417.484 113.959 474.911L756.089 1117.04C813.515 1174.47 907.485 1174.47 964.911 1117.04L1607.04 474.911C1664.47 417.484 1664.47 323.514 1607.04 266.088L966.652 -376.042C909.225 -433.468 815.255 -433.468 757.829 -376.042L113.959 266.088Z",
    stroke: "#002853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.825 277.818C146.85 328.793 146.85 412.207 197.825 463.182L767.818 1033.17C818.793 1084.15 902.207 1084.15 953.182 1033.17L1523.17 463.182C1574.15 412.207 1574.15 328.793 1523.17 277.818L954.726 -292.175C903.751 -343.15 820.338 -343.15 769.363 -292.175L197.825 277.818Z",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_52_890",
    transform: "translate(-0.134341 -0.135324) scale(0.00033878)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDoubleSquare);
export default __webpack_public_path__ + "static/media/BgDoubleSquare.2f26f4605545019d2112cab7701b439a.svg";
export { ForwardRef as ReactComponent };